import { Link } from 'react-router-dom';
import { titles } from '@/mocks/titles';
import RatingBadge from '@/components/base/RatingBadge';

export default function LatestUpdates() {
  const latest = [...titles]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 8);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
      {latest.map((item, index) => (
        <Link
          key={item.id}
          to={`/detail/${item.id}`}
          className="group flex items-center gap-3 md:gap-4 p-3 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
        >
          <span
            className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-md text-sm font-bold ${
              index < 3 ? 'bg-accent-500 text-primary-950' : 'bg-background-200 text-foreground-600'
            }`}
          >
            {index + 1}
          </span>
          <div className="w-12 h-16 shrink-0 rounded-md overflow-hidden bg-background-200">
            <img src={item.poster} alt={`${item.title}海报`} title={`${item.title}在线观看`} className="w-full h-full object-cover object-top" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 truncate group-hover:text-primary-700 transition-colors">
              {item.title}
            </h3>
            <div className="flex flex-wrap items-center gap-2 mt-1 text-xs text-foreground-600">
              <span className={`rounded-md px-1.5 py-0.5 ${item.type === 'movie' ? 'bg-secondary-100 text-secondary-900' : 'bg-primary-100 text-primary-800'}`}>
                {item.type === 'movie' ? '电影' : '电视剧'}
              </span>
              <span>{item.year}</span>
              <span className="text-foreground-300">·</span>
              <span>{item.region}</span>
            </div>
            <span className="inline-flex items-center gap-1 mt-1.5 text-xs text-accent-700 bg-accent-100 rounded-md px-1.5 py-0.5">
              <i className="ri-time-line"></i>更新 {item.updatedAt}
            </span>
          </div>
          <div className="shrink-0 hidden sm:block">
            <RatingBadge rating={item.rating} size="sm" />
          </div>
        </Link>
      ))}
    </div>
  );
}